// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"0e0df091","297":"831add2f"}[chunkId] + ".chunk.js";
};